import { Waves, Wifi, Car, MapPin } from "lucide-react";
import { IMG } from "../lib/images";
import { useLanguage } from "../lib/LanguageContext";

export const Hero = () => {
  const { t } = useLanguage();
  const highlights = [
    { icon: MapPin, label: t("hero_h1_900m") },
    { icon: Waves, label: t("hero_h1_pool") },
    { icon: Wifi, label: t("hero_h1_wifi") },
    { icon: Car, label: t("hero_h1_agios") },
  ];

  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-[100vh] flex items-end overflow-hidden"
    >
      <img
        src={IMG.poolMountain}
        alt="Athina Villas pool with Cretan mountain view"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0a192f]/85 via-[#0a192f]/55 to-[#0a192f]/20" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0a192f]/70 via-transparent to-[#0a192f]/30" />

      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute right-6 bottom-10 hidden md:flex items-center gap-3 text-white/80 text-[10px] uppercase tracking-[0.32em]">
          <span className="h-px w-10 bg-white/50" />
          {t("hero_loc")}
        </div>
      </div>

      <div className="relative z-10 max-w-7xl w-full mx-auto px-6 md:px-10 pb-20 pt-32 md:pb-28">
        <div className="max-w-2xl">
          <div
            data-testid="hero-eyebrow"
            className="inline-flex items-center gap-3 text-white/85 text-[10px] uppercase tracking-[0.32em] mb-8"
          >
            <span className="h-px w-12 bg-white/60" />
            {t("hero_eyebrow")}
          </div>
          <h1
            data-testid="hero-headline"
            className="font-serif text-white text-5xl sm:text-6xl lg:text-7xl font-light leading-[0.95] tracking-tight drop-shadow-[0_2px_24px_rgba(0,0,0,0.35)]"
          >
            {t("hero_h1_a")}
            <br />
            <span className="italic text-[#c9d8c5]">{t("hero_h1_b")}</span>{" "}
            {t("hero_h1_c")}
            <br />
            {t("hero_h1_d")}
          </h1>
          <p
            data-testid="hero-subhead"
            className="mt-8 max-w-xl text-white/85 text-base md:text-lg font-light leading-relaxed"
          >
            {t("hero_sub")}
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href="#contact"
              data-testid="hero-cta-book"
              className="bg-[#faf9f6] text-[#0a192f] hover:bg-white px-9 py-4 rounded-full text-[12px] uppercase tracking-[0.22em] font-medium transition-colors"
            >
              {t("hero_cta_book")}
            </a>
            <a
              href="#apartments"
              data-testid="hero-cta-explore"
              className="border border-white/60 text-white hover:bg-white hover:text-[#0a192f] px-9 py-4 rounded-full text-[12px] uppercase tracking-[0.22em] font-medium transition-colors backdrop-blur-sm"
            >
              {t("hero_cta_explore")}
            </a>
          </div>
        </div>

        <div
          data-testid="hero-highlights"
          className="mt-16 md:mt-24 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-0 md:border-t md:border-white/20 md:pt-8"
        >
          {highlights.map((h, i) => (
            <div
              key={i}
              data-testid={`hero-highlight-${i}`}
              className={`flex items-center gap-3 text-white/90 ${
                i !== 0 ? "md:pl-8" : ""
              } ${i !== highlights.length - 1 ? "md:border-r md:border-white/20" : ""}`}
            >
              <h.icon className="h-4 w-4 text-[#c9d8c5]" strokeWidth={1.4} />
              <span className="text-[11px] md:text-xs uppercase tracking-[0.18em] leading-tight">
                {h.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
